export const messages = {
  en: {
    complaint: {
      type: 'Complaint Type',
      typePlaceholder: 'Required, please select complaint type',
      typeComplaint: 'Complaint',
      typeSuggestion: 'Suggestion',
      typeRequired: 'Complaint type is required',
      typeFormatError: 'Invalid complaint type format',
      name: 'Complainant',
      namePlaceholder: 'Required, please enter complainant name',
      nameRequired: 'Complainant name is required',
      nameMaxLength: 'Complainant name cannot exceed 200 characters',
      phone: 'Phone',
      phonePlaceholder: 'Required, please enter phone number',
      phoneRequired: 'Phone number is required',
      phoneFormatError: 'Invalid phone number format',
      content: 'Content',
      contentPlaceholder: 'Required, please enter complaint content',
      contentRequired: 'Content is required',
      contentMaxLength: 'Content cannot exceed 4000 characters',
      submitSuccess: 'Submitted successfully',
      submitFailed: 'Submission failed'
    }
  },
  zh: {
    complaint: {
      type: '投诉类型',
      typePlaceholder: '必填，请选择投诉类型',
      typeComplaint: '投诉',
      typeSuggestion: '建议',
      typeRequired: '投诉类型不能为空',
      typeFormatError: '投诉类型格式错误',
      name: '投诉人',
      namePlaceholder: '必填，请填写投诉人',
      nameRequired: '投诉人不能为空',
      nameMaxLength: '投诉人不能大于200位',
      phone: '投诉电话',
      phonePlaceholder: '必填，请填写投诉电话',
      phoneRequired: '投诉电话不能为空',
      phoneFormatError: '投诉电话格式错误',
      content: '投诉内容',
      contentPlaceholder: '必填，请填写投诉内容',
      contentRequired: '投诉内容不能为空',
      contentMaxLength: '投诉状态超过4000位',
      submitSuccess: '处理成功',
      submitFailed: '处理失败'
    }
  }
}